export const PRICING_PAGE = "https://www.teamable.com/contact";
